import { useNavigate } from 'react-router-dom';
import { SparklesIcon as SolidSparklesIcon } from '@heroicons/react/24/solid';

import { Button } from '@oysterjs/ui/button';
import {
  DialogActions,
  DialogDescription,
  DialogTitle,
  MountableDialog
} from '@oysterjs/ui/dialog';

/**
 * Upsell dialog shown when an agency tries to use a Pro-only library feature
 * (currently just custom forms). On confirm, navigates to subscription
 * settings; on cancel, just closes.
 */
export function ProUpgradeDialog(props: {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  if (!props.open) return null;
  return (
    <MountableDialog onClose={props.onClose} size="lg">
      <div className="flex items-center gap-3">
        <div className="inline-flex shrink-0 items-center justify-center rounded-xl bg-amber-100 dark:bg-amber-500/20 p-2.5">
          <SolidSparklesIcon className="size-5 text-amber-600 dark:text-amber-400" />
        </div>
        <DialogTitle className="text-wrap m-0">{props.title}</DialogTitle>
      </div>
      <DialogDescription>{props.description}</DialogDescription>
      <DialogActions>
        <Button color="white" onClick={props.onClose}>
          Maybe Later
        </Button>
        <Button
          color="sky"
          onClick={() => {
            props.onClose();
            navigate('/app/settings/subscription');
          }}
        >
          <SolidSparklesIcon />
          Upgrade to Pro
        </Button>
      </DialogActions>
    </MountableDialog>
  );
}
